<template>
  <span class="bg-pill" :class="classes" :data-tooltip="hint">
    <fa-icon :icon="['fal', icon]"/>{{ name }}
    <span v-if="round" class="bg-status-round">· {{ roundName }}</span>
  </span>
</template>

<script>
import { getName, getIcon, hints } from '@/data/billing-gloss-statuses';
import { getRoundName } from '@/data/billing-appeal-statuses';

const CLASSES = {
  open: 'bg-pill-red',
  appealed: 'bg-pill-amber',
  overturned: 'bg-pill-green',
  partially_overturned: 'bg-pill-green-amber',
  maintained: 'bg-pill-red-strong',
  accepted: 'bg-pill-gray',
};

export default {
  props: {
    status: {
      type: String,
      required: true,
    },
    round: {
      type: Number,
      default: null,
    },
  },
  computed: {
    name() {
      return getName(this.status);
    },
    icon() {
      return getIcon(this.status);
    },
    hint() {
      return hints[this.status] || null;
    },
    roundName() {
      return getRoundName(this.round);
    },
    classes() {
      const list = [CLASSES[this.status] || 'bg-pill-gray'];
      if (this.hint) list.push('tooltip');
      return list;
    },
  },
};
</script>
